import type { IconName } from '@designSystem/fondation/icons/iconsList'
import type { ContactAktoDTO } from '@/features/api/extranet/dto/shared'
import type { ContactAvecFavoris } from './useContactsFavorisStore'

export function useContactCardMapping() {
  function buildSubtitles(contact: ContactAktoDTO): SubtitleProps[] {
    const subtitles: SubtitleProps[] = []

    if (contact.fonction && contact.fonction.trim()) {
      subtitles.push({ text: contact.fonction })
    }

    if (contact.email && contact.email.trim()) {
      subtitles.push({ text: contact.email, icon: 'email-tracking' })
    }

    if (contact.telephone && contact.telephone.trim()) {
      subtitles.push({ text: contact.telephone, icon: 'call-calling' })
    }

    return subtitles
  }

  function mapContactToCard(contact: ContactAvecFavoris): CardProps {
    return {
      avatar: getAvatar(contact),
      title: `${contact.nom ?? ''} ${contact.prenom ?? ''}`.trim(),
      subtitles: buildSubtitles(contact),
      showFavoris: contact.estFavoris,
      isFavoris: contact.estFavoris,
    }
  }

  return {
    buildSubtitles,
    mapContactToCard,
  }
}

function getAvatar(contact: ContactAvecFavoris): AvatarProps {
  if (contact.typeContact === 'CoordonneesRegion' || contact.typeContact === 'CoordonneesWeb') {
    return {
      type: 'icon',
      iconName: 'call-center' as IconName,
    }
  }

  return {
    type: 'name',
    name: `${contact.nom ?? ''} ${contact.prenom ?? ''}`.trim(),
  }
}
